import { useCallback, useEffect } from 'react';
import { SidebarSlider } from '@creditflowresearch/uilib/SidebarSlider';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import { useBondScreenerViewsContext } from '@/creditflowresearch/application/BondScreener/Sidebar/BondScreenerViewsContext';
import {
  BondScreenerCustomizationPanel,
  CustomizationPanelViewSelect,
  CUSTOMIZATION_PANEL_TAB_IDS,
  useCustomizationPanel,
} from '@/creditflowresearch/ui/components/bondscreener/CustomizationPanel';
import { useIsGuest } from '@/creditflowresearch/application/User/access';

import { CorporateBondScreenerSidebarFooter } from './CorporateBondScreenerSidebarFooter';
import { FiltersTabContent } from './CustomizationPanel/FiltersTabContent';

interface IProps {
  isOpen: boolean,
  onClose: () => void,
}

export const CorporateBondScreenerSidebarPanel = ({ isOpen, onClose }: IProps) => {
  const { resetKey } = useCorporateBondScreenerSidebarFilterContext();
  const { discardActiveView } = useBondScreenerViewsContext();
  const { activeTab, setActiveTab } = useCustomizationPanel();
  // TODO: remove when the European market opening period ends
  const isViewRestricted = useIsGuest();

  useEffect(() => {
    if (!isOpen) {
      setActiveTab(CUSTOMIZATION_PANEL_TAB_IDS.FILTERS);
    }
  }, [isOpen]);

  const handleClose = useCallback((): void => {
    discardActiveView();
    onClose();
  }, [discardActiveView, onClose]);

  return (
    <SidebarSlider
      isOpen={ isOpen }
      onClose={ handleClose }
      confirmOnClose
      header={ null }
      footer={ <CorporateBondScreenerSidebarFooter /> }
    >
      <BondScreenerCustomizationPanel
        activeTab={ activeTab }
        onTabChange={ setActiveTab }
        resetKey={ resetKey }
        viewSelect={ <CustomizationPanelViewSelect isRestricted={ isViewRestricted } /> }
        filtersContent={ <FiltersTabContent activeTab={ activeTab } resetKey={ resetKey } /> }
      />
    </SidebarSlider>
  );
};
